/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    RuleFormDataAgencyOrGroup,
    RuleFormDataAgencyOrGroupFromJSON,
    RuleFormDataAgencyOrGroupToJSON,
} from '../models';

export interface ApiCommonAgencyBuildRuleFormDataAgencyOrGroupGetRequest {
    id?: string;
}

/**
 * no description
 */
export class AgencyApi extends runtime.BaseAPI {

    /**
     */
    async apiCommonAgencyBuildRuleFormDataAgencyOrGroupGetRaw(requestParameters: ApiCommonAgencyBuildRuleFormDataAgencyOrGroupGetRequest): Promise<runtime.ApiResponse<RuleFormDataAgencyOrGroup>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.id !== undefined) {
            queryParameters['id'] = requestParameters.id;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/Common/Agency/BuildRuleFormDataAgencyOrGroup`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => RuleFormDataAgencyOrGroupFromJSON(jsonValue));
    }

    /**
     */
    async apiCommonAgencyBuildRuleFormDataAgencyOrGroupGet(requestParameters: ApiCommonAgencyBuildRuleFormDataAgencyOrGroupGetRequest): Promise<RuleFormDataAgencyOrGroup> {
        const response = await this.apiCommonAgencyBuildRuleFormDataAgencyOrGroupGetRaw(requestParameters);
        return await response.value();
    }

}
